/* unplugin-vue-components disabled */import { render } from "./TeachingClassView.vue?vue&type=template&id=83b7989c&scoped=true"
import script from "./TeachingClassView.vue?vue&type=script&lang=js"
export * from "./TeachingClassView.vue?vue&type=script&lang=js"

import "./TeachingClassView.vue?vue&type=style&index=0&id=83b7989c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b7989c"]])

export default __exports__